import common from "common";
import httpRequest from "./httpUtils";
import utils from "./utils"
/* httpRequest方法 默认post请求
 * post 请求 参数名称 data
 * get  请求 参数名称 params
 * */
function getAPIList(success, fail) {
  let data = {
    version: common.version,
    https: 1
  };
  httpRequest({
    code: "700018",
    data,
    success: function(res, ok) {
      if (!ok) return;
      let apiListUrl = {
        "800004":res.kejianSound.fileUrl
      };
      res.apiList.forEach((k, i) => {
        apiListUrl[k.name] = k.url;
      });
      common.API = apiListUrl;
      common.set("apiListUrl", apiListUrl);
      common.set("isHeaderVersion",res.ignoreHeaderIds);
      // if(LIMI_ENV==="electron"){
      //   utils.setNodeStorge("domainList",res.domainList);
      // }
      success(res);
    },
    fail: fail
  });
}
/**
 * 输入手机号码登陆
 * @param  phone 用户手机号码
 * @param success 成功回调函数
 */
function login(data, success) {
  httpRequest({ code: "700032", data, success });
}
//获取可切换环境列表
function getEnvList(success, fail) {
  const data = {
    platform:"coach"
  }
  httpRequest({ code: "100001", data, success, fail });
}
//小动物登陆-coach
function animalLogin(data, success, fail) {
  httpRequest({ code: "700033", data, success, fail });
}
//获取课程列表 coach
function getLessonList(data, success, fail) {
  httpRequest({ code: "700004", data, success, fail });
}
//获取体验课列表
function getExperienceLessonList(data, success, fail){
  httpRequest({ code: "300230", data, success, fail });
}
//获取快速问答 coach
function quickQuestion(params, success) {
  let method = "get";
  httpRequest({ code: "700009", method, params, success });
}

//标准问答 coach
function standardQuestion(params,success) {
  let method = "get";
  httpRequest({ code: "700008",params, method, success });
}
//体验课标准问答
function standardQuestionExp(params,success) {
  let method = "get";
  httpRequest({ code: "400025",params, method, success });
}
//回放页获取标准问答
function standardQuestionPlayBack(params,success) {
  let method = "get";
  httpRequest({ code: "400028",params, method, success });
}
//我的班 coach
function getClassList(data, success, fail,config) {
  httpRequest({ code: "800049", data, success, fail ,config});
}
//获取资源文件 coach
function getZip(data, success) {
  httpRequest({ code: "700020", data, success });
}
//轮训代替长连接
function getMsgClient(params, success) {
  let method = "get";
  httpRequest({ code: "300117", params, method, success });
}
//API进课消息 coach
function lessonIn(data, success, fail) {
  httpRequest({ code: "700005", data, success, fail });
}
//补发长连接消息
function sendSocketData(data, success, fail) {
  httpRequest({ code: "700030", data, success, fail });
}
//获取当前登录学生获取的徽章或者同小班的同学获取的徽章
//注：获取同小班同学徽章时需传小班ID以及同学ID
function usercenterBadgeList(data, success, fail) {
  httpRequest({ code: "300163", data, success, fail });
}
//修改用户头像 coach
function modifyPhoto(data, success) {
  httpRequest({ code: "700015", data, success });
}
//获取默认头像列表 coach
function getDefaultPhotoList(data, success) {
  httpRequest({ code: "700016", data, success });
}
//获取要上课的lesson的状态
function getLessonsState(data, success) {
  httpRequest({ code: "300185", data, success });
}
//退课 coach
function lessonOut(data, success) {
  httpRequest({ code: "700006", data, success });
}
// 退课-录播
function recordLessonOut(data, success) {
  httpRequest({ code: "400035", data, success });
}
//获取所有课件题json coach
function getKejianJson(data, success) {
  httpRequest({ code: "700014", data, success });
}
//获取徽章信息
function getBadgeInVideo(params, success, fail) {
  let method = "get";
  httpRequest({ code: "300136", method, params, success, fail });
}
//评论提交
function commitComment(data, success, fail) {
  httpRequest({ code: "300209", data, success, fail });
}
//获取拉流地址接口 coach
function getPullUrl(data, success, fail) {
  httpRequest({ code: "700013", data, success, fail });
}
//获取发题记录
function getSendLog(data, success, fail) {
  httpRequest({ code: "300142", data, success, fail });
}
//获取发题记录-录播课 coach
function getSendLogForRecord(data, success, fail) {
  httpRequest({ code: "700019", data, success, fail });
}
// coach
function isPlayTime(data, success, fail) {
  httpRequest({ code: "700027", data, success, fail });
}
//获取发题记录
function getPlaybackSendLog(data, success, fail) {
  httpRequest({ code: "300201", data, success, fail });
}
//门店虚拟体验课答题API coach
function expAnswerQuestion(data, success, fail) {
  httpRequest({ code: "700007", data, success, fail });
}
//检查更新 coach
function getLatestVersion(data, success, fail) {
  httpRequest({ code: "700017", data, success, fail });
}
//获取ai伪弹幕
function getFalseBarrage(data, success, fail) {
  httpRequest({ code: "700031", data, success, fail });
}

//课前测答案上报 coach
function sendPreQuestion(data, success, fail) {
  httpRequest({ code: "700028", method: "Post", data, success, fail });
}
//课中排行榜
function getAnswerRank(data, success, fail) {
  httpRequest({ code: "300171", data, success, fail });
}
//课中排行榜
function getBadgeRank(data, success, fail) {
  httpRequest({ code: "300173", data, success, fail });
}
//班级列表页面基础数据（公告、个人信息、小游戏） coach
function getClassPageBaseData(data, success, fail,config) {
  httpRequest({ code: "700011", data, success, fail ,config});
}
//首页徽章上报
function uploadBadge(data, success, fail) {
  httpRequest({ code: "300146", data, success, fail });
}
//获取长连接灾备地址
function getLivemsgAddr(data, success, fail) {
  httpRequest({ code: "300154", data, success, fail });
}
//获取服务器时间 coach
function getServerTime(data, success, fail) {
  httpRequest({ code: "700025", data, success, fail });
}
function getMsgList(data, success, fail,config) {
  //消息列表查询
  httpRequest({ code: "300199", method: "post", data, success, fail,config});
}
function getMsgDetail(data, success, fail) {
  //消息列表查询
  httpRequest({ code: "300159", method: "post", data, success, fail });
}
function delMessage(data,  success) {
  //消息列表查询
  httpRequest({ code: "300160", method: "post",data, success });
}
//问题反馈 coach
function problemFeedback(data, success, fail){
  httpRequest({ code: "700024", method: "post",data, success, fail });
}
//问题反馈类型 coach
function getBugTyptList(params, success){
  httpRequest({ code: "700022",method: "get",params, success });
}
//获取ossToken coach
function getOssToken(params,success, fail) {
  httpRequest({ code: "700021", method: "get", params, success, fail });
}
//oss上传语音成功 coach
function uploadOssSuccess(data,success, fail) {
  httpRequest({ code: "700023", data, success, fail });
}
//直接跳转直播页面 coach
function getTeacherLessonInfo(data, success, fail){
  httpRequest({ code: "700029", method: "post",data, success, fail });
}
//语音连麦上报异常
function uplodeTelephoneError(data, success, fail){
  httpRequest({ code: "300174", method: "post",data, success, fail });
}
//获取礼物列表 coach
function getImageResources(data, success, fail){
  httpRequest({ code: "700012", method: "post",data, success, fail });
}
//直播回放持续观看时间上报 coach
function durationRport(data, success, fail){
  httpRequest({ code: "900007", method: "post",data, success, fail });
}
// 续播上报
function continuationRport(data, success, fail){
  httpRequest({ code: "900008", method: "post",data, success, fail });
}
//表扬数据
function getPraiseInfo(data, success, fail) {
  httpRequest({ code: "300178", data, success, fail });
}
//礼物礼物补发
function apiSendGift(data, success, fail) {
  httpRequest({ code: "300177", data, success, fail });
}
// 获取验证码 - coach
function getCode(data, success, fail) {
  httpRequest({ code: "700001", data, success, fail });
}
// 重置密码
function resetPwd(data, success, fail) {
  httpRequest({ code: "700034", data, success, fail });
}
// 校验验证码
function regCode(data, success, fail) {
  httpRequest({ code: "700035", data, success, fail });
}
// 验证码登录 coach
function verifyCodeLogin(data, success, fail) {
  httpRequest({ code: "700002", data, success, fail });
}
// 设置弹幕字体颜色接口
function setFontColor(data, success, fail) {
  httpRequest({ code: "700036", data, success, fail });
}
//pk补发接口
function sendPkData(data, success, fail) {
  httpRequest({ code: "300189", data, success, fail });
}
//课后练习首页 coach
function exerciseIndex(data, success, fail) {
  httpRequest({ code: "700037", data, success, fail });
}
//清除课后练习数据 coach
function clearExercise(data, success, fail) {
  httpRequest({ code: "700044", data, success, fail });
}
//课后练习保存每道题答题信息
function exerciseQuestionSave(data, success, fail) {
  httpRequest({ code: "700038", data, success, fail });
}
//课后练习答题卡提交
function exerciseSubmit(data, success, fail) {
  httpRequest({ code: "700039", data, success, fail });
}
//课后练习订正
function exerciseCorrect(data, success, fail) {
  httpRequest({ code: "700040", data, success, fail });
}
// 获取快速问答选择题样式 coach
function getXuanZeStyle(data, success, fail) {
  httpRequest({ code: "700026", data, success, fail });
}
// 获取头饰列表
function getHeadwearList(data, success, fail) {
  httpRequest({ code: "400026", data, success, fail });
}
function updateHeadwear(data, success, fail) {
  httpRequest({ code: '400027', data, success, fail })
}
export default {
  getAPIList,
  login,
  getLessonList,
  animalLogin,
  quickQuestion,
  standardQuestion,
  standardQuestionExp,
  standardQuestionPlayBack,
  getClassList,
  getMsgClient,
  lessonIn,
  sendSocketData,
  usercenterBadgeList,
  getZip,
  modifyPhoto,
  getDefaultPhotoList,
  getLessonsState,
  lessonOut,
  recordLessonOut,
  getKejianJson,
  getEnvList,
  commitComment,
  getBadgeInVideo,
  getPullUrl,
  getSendLog,
  getSendLogForRecord,
  isPlayTime,
  expAnswerQuestion,
  getLatestVersion,
  getFalseBarrage,
  sendPreQuestion,
  getAnswerRank,
  getBadgeRank,
  getClassPageBaseData,
  uploadBadge,
  getLivemsgAddr,
  getServerTime,
  getMsgList,
  getMsgDetail,
  delMessage,
  problemFeedback,
  getBugTyptList,
  getOssToken,
  uploadOssSuccess,
  getTeacherLessonInfo,
  uplodeTelephoneError,
  getImageResources,
  durationRport,
  continuationRport,
  getPraiseInfo,
  apiSendGift,
  getCode,
  resetPwd,
  regCode,
  setFontColor,
  sendPkData,
  verifyCodeLogin,
  getPlaybackSendLog,
  exerciseIndex,
  clearExercise,
  exerciseQuestionSave,
  exerciseSubmit,
  exerciseCorrect,
  getXuanZeStyle,
  getExperienceLessonList,
  getHeadwearList,
  updateHeadwear
};



// WEBPACK FOOTER //
// ./src/js/liSrv.js